import React from 'react'
import { PageContent, ContentMenu, ContentMenuTab, Heading, Text, Image, MapWidget, MapMenu, MapItem } from 'components/library'
import aspect04img01 from './assets/Toren_SemiClose_2.jpg'
import mapBaseImage from './assets/basiskaart-squared.jpg'
import './Aspect04.css'

class Aspect04 extends React.Component {

  state = {
    intro: 0,
  }

  render() {
    return (
      <div className="Chapter01-Aspect04">
        <PageContent nospacing>

            <ContentMenu
            menuOnTop
            activeHasBackground
            tabs={[
              'Apron Control',
              'Sleepoverzicht',
            ]} >

              <ContentMenuTab>
                <div className="has-two-col">
                  <div className="first-col">
                    <Heading h2>Heb je problemen met je oriëntatie in het landingterrein? Vraag hulp bij Apron Control!</Heading>
                    <Text>Zodra je merkt dat je problemen hebt met oriënteren in het landingsterrein stop je direct met de sleep door je op een veilige locatie te positioneren. Dit is een locatie vrij van baankruisingen. Vervolgens neem je contact op met Apron Control. Zij zullen je lokaliseren en verder begeleiden. Je vervolgt je route vervolgens onder begeleiding van Apron Control. Het kan ook zijn dat ze een voertuig naar je toesturen om je verder te begeleiden.</Text>
                    <Text>Kortom, twijfel je over de route van de sleep? Vraag hulp bij Apron Control!</Text>
                  </div>
                  <div className="last-col">
                    <Image src={aspect04img01}/>
                  </div>
                </div>
              </ContentMenuTab>

              <ContentMenuTab>
                <MapWidget
                  mapImage={mapBaseImage}
                  mapBounds={[[0, 0], [2552, 2552]]}
                  options={{ minZoom: -1.05 }}>
                    <MapMenu>
                      <MapItem center={[1195,1246]} zoom={-1.05} />
                    </MapMenu>
                </MapWidget>

                {this.state.intro === 0 &&
                  <div className="Aspect-intro">
                    <div className="Aspect-intro-inner">
                      <div>
                        <Heading h3>Sleepoverzicht</Heading>
                        <Text>Het sleepoverzicht dient als hulpmiddel in het landingsterrein. Je kunt deze digitaal raadplegen, of afhalen bij het VTC. Het sleepoverzicht kun je in de volgende situaties gebruiken:</Text>
                        <ul>
                          <li>Voordat je start met de sleepbeweging om de route en eventuele bijzonderheden op te zoeken.</li>
                          <li>Als je twijfelt over de route.</li>
                          <li>Als je naar een nieuwe locatie moet rijden, zoals bijvoorbeeld het Uniform-platform</li>
                          <li>Als je naar een locatie moet rijden waar je weinig komt.</li>
                          <li>Als je gedesoriënteerd raakt in het veld.</li>
                        </ul>
                      </div>
                      <div>
                        <a onClick={() => (this.setState({ intro: 1, }))}>Bekijk het sleepoverzicht</a>
                      </div>
                    </div>
                  </div>
                }
              </ContentMenuTab>

            </ContentMenu>

        </PageContent>
      </div>
    )
  }
}

export default Aspect04



// WEBPACK FOOTER //
// ./src/content/chapters/01/04/Aspect04.js